module.exports = __webpack_public_path__ + "static/img/sorry.cf43579.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/img/sorry.png
// module id = Uu47
// module chunks = 1